import Vue from 'vue'
import Router from 'vue-router'
import Index from './views/Index.vue'
import Login from './views/Login.vue'

Vue.use(Router);

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/index',
            name: 'index',
            component(resolve) {
                require(['./views/Index.vue'], resolve)
            }
        },
        {
            path: '/',
            name: 'login',
            component(resolve) {
                require(['./views/Login.vue'], resolve)
            }
        }
    ]
})